import {ActionTypes} from '../types/actionTypes';
import {ScanStatus} from '../types/enumTypes';
import {Action} from '../typescript/actionTypes';
import {StoreTimesheetFromClient} from '../typescript/storeTypes';
import {InitialState} from './initialState';

export default function (state: {[assignmentId: number]: StoreTimesheetFromClient[]} = InitialState.timesheetsFromClient, action: Action): {[assignmentId: number]: StoreTimesheetFromClient[]} {
    switch (action.type) {
        case ActionTypes.GET_TIMESHEETS_FROM_CLIENT_INFO_SUCCEEDED: {
            return Object.assign({}, state, {[action.payload.assignmentId]: action.payload.body});
        }
        case ActionTypes.DELETE_ASSIGNMENTDOCUMENT_SUCCEEDED: {
            const currentDocs = state[action.payload.assignmentId] ?? [];
            const deletedAssignmentDocumentIndex = currentDocs.findIndex(a => a.assignmentDocumentId === action.payload.assignmentDocumentId);

            // Without this guard splice(-1) would drop the last document instead of the deleted one.
            if(deletedAssignmentDocumentIndex === -1) return state;

            const assignmentDocs = Object.assign([], currentDocs);
            assignmentDocs.splice(deletedAssignmentDocumentIndex, 1);
            return Object.assign({}, state, {[action.payload.assignmentId]: assignmentDocs});
        }
        case ActionTypes.UPLOAD_CLIENTTIMESHEET_SUCCEEDED: {
            const newAssignmentDoc = {
                assignmentDocumentId: action.payload.assignmentDocumentId,
                assignmentId: action.payload.assignmentId,
                documentName: action.payload.documentName,
                uploadedOn: new Date().toISOString(),
                scanStatus: ScanStatus.Pending
            };
            const newDocs = Object.assign([], state[action.payload.assignmentId]);
            newDocs.push(newAssignmentDoc);
            return Object.assign({}, state, {[action.payload.assignmentId]: newDocs});
        }
        default: {
            return state;
        }
    }
}
